import type { Category, ReportReason } from './api';

export interface CategoryInfo {
  value: Category;
  label: string;
  /** Short hint shown in the composer. */
  hint: string;
}

export const CATEGORIES: readonly CategoryInfo[] = [
  { value: 'note', label: 'Neighbor note', hint: 'General news and friendly notes' },
  { value: 'question', label: 'Question', hint: 'Ask the people around you' },
  { value: 'alert', label: 'Alert', hint: 'Something neighbors should know about now' },
  { value: 'lost_found', label: 'Lost & found', hint: 'Pets, keys, packages' },
  { value: 'recommendation', label: 'Recommendation', hint: 'Plumbers, taquerias, trailheads' },
];

export function categoryLabel(category: Category): string {
  return CATEGORIES.find((c) => c.value === category)?.label ?? category;
}

export const REPORT_REASONS: readonly { value: ReportReason; label: string }[] = [
  { value: 'spam', label: 'Spam or advertising' },
  { value: 'harassment', label: 'Harassment or bullying' },
  { value: 'hate', label: 'Hateful or discriminatory' },
  { value: 'privacy', label: "Shares someone's private information" },
  { value: 'misinformation', label: 'False or misleading' },
  { value: 'not_local', label: "Doesn't seem to be from a neighbor" },
  { value: 'other', label: 'Something else' },
];

export function reportReasonLabel(reason: ReportReason): string {
  return REPORT_REASONS.find((r) => r.value === reason)?.label ?? reason;
}
